import { Autocomplete, CircularProgress, TextField } from "@mui/material"
import { useGetProductsQuery } from "@store/services/productsService"
import { useImmerAtom } from "jotai-immer"
import { memo } from "react"
import { AutocompleteOnChange, OrgToDivToProds } from "@components/NodeLink/types"
import { linkAtom } from "@components/NodeLink/linkAtom"

const ProdAutocomplete = memo((props: { orgToDivToProds: OrgToDivToProds }) => {
  const [link, updateLink] = useImmerAtom(linkAtom)
  const { isFetching } = useGetProductsQuery({ roleHint: "whatif" })
  const skip = !link.org || !link.div

  const handleChange: AutocompleteOnChange = (_event, newValue) => {
    updateLink((draft) => {
      draft.prod = newValue ?? ""
      draft.family = ""
      draft.version = ""
      draft.node = ""
    })
  }

  const products = [...(props.orgToDivToProds.get(link.org)?.get(link.div)?.values() ?? [])]
  const sortedOptions = products.toSorted((prodA, prodB) => prodA.localeCompare(prodB))

  return (
    <Autocomplete
      options={sortedOptions}
      value={link.prod || null}
      onChange={handleChange}
      renderInput={(params) => <TextField {...params} label="Product" />}
      disabled={skip}
      isOptionEqualToValue={(option, value) => option === value}
      loading={isFetching}
      loadingText={<CircularProgress size={20} />}
    />
  )
})
ProdAutocomplete.displayName = "ProdAutocomplete"

export default ProdAutocomplete
